import { EnvironmentService } from '@/services/environment';
import { SentryService } from '@/services/sentry';

EnvironmentService.init();
SentryService.init();
